import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { config } from 'app/config';
import { user } from 'services';
import { path } from 'router/sections';
import { LangSelector } from '../translation/lang-selector';
import { Tooltip } from '../tooltip/tooltip';
import { LayoutContainer, HeaderContainer, HeaderWrapper, BrandName, Login, LinksContainer, MenuLink, Right } from './layout.styled';

export const Layout = ({ children, sections }) => {
  const { t } = useTranslation();

  /**
   * open external mnemo
   * @param {*} e
   */
  const openMnemonicDiagram = (e) => {
    e.preventDefault();
    const token = user.getToken();
    const popup = window.open(config.network.mnemonic_diagram_url + '?token=' + token, '_blank', 'toolbar,scrollbars,resizable,top=110,left=0,width=' + window.screen.width + ',height=' + window.screen.height);
    popup.moveTo(101, 101);
  };

  const getMenuLinks = () => {
    return sections
      .filter((el) => el.type === 'section')
      .map((el, idx) => {
        return (
          <MenuLink key={idx} to={el.path} onClick={el.id === 'scheme' ? openMnemonicDiagram : null}>
            {t('sections.' + el.name)}
          </MenuLink>
        );
      });
  };

  return (
    <LayoutContainer>
      <HeaderContainer>
        <HeaderWrapper>
          <BrandName>
            <NavLink to={path('stays')}>
              <img src="/images/cleverpark.svg" alt="CLEVER PARK" />
            </NavLink>
          </BrandName>
          <LinksContainer>{getMenuLinks()}</LinksContainer>
          <Right>
            <LangSelector flags abs={false} />
            <Login>
              {user.info ? user.info?.name : ''}
              <i className="fa fa-sign-out" onClick={() => user.logoutUser()} />
            </Login>
          </Right>
        </HeaderWrapper>
      </HeaderContainer>
      <>
        <Tooltip />
        {children}
      </>
    </LayoutContainer>
  );
};
